// Shared compose overlay state for the shell's + button, quotes and thread parts.
// The shell centers it on desktop and places it at the bottom on mobile.

import { create } from 'zustand';

interface ComposeSheetState {
  open: boolean;
  openSheet: () => void;
  closeSheet: () => void;
}

export const useComposeSheetStore = create<ComposeSheetState>()((set) => ({
  open: false,
  openSheet: () => set({ open: true }),
  closeSheet: () => set({ open: false }),
}));
